<template>
	<div>
		<MobileHeader v-if="isMobile"></MobileHeader>
		<div v-else class="nav">
			<div class="logo" @click="routerJump('/home')">
				<img
					src="https://oss.cuttlefish.vip/file/h5upload/178884522481666349681.png"
					alt="墨鱼旅行"
				/>
			</div>
			<ul class="nav-list">
				<li
					v-for="item in navList"
					:key="item.id"
					@click="routerJump(item.path)"
					:style="{ color: path === item.path ? '#26A1FF' : color }"
				>
					{{ item.name }}
				</li>
			</ul>
		</div>
		<router-view></router-view>
		<div v-if="showContactSection" class="contact-us">
			<div class="dynamic-actions">
				<button class="dynamic-btn brand" type="button" @click="brandVisible = true">
					品牌动态
				</button>
				<button class="dynamic-btn person" type="button" @click="personVisible = true">
					人物动态
				</button>
			</div>
			<div class="contact-us-title">联系我们</div>
			<div class="contact-us-content">
				<div class="contact-us-item">
					<span class="contact-us-left">客服热线</span
					><span class="contact-us-right">400 886 9966</span>
				</div>
				<div class="contact-us-item">
					<span class="contact-us-left">官方邮箱</span
					><span class="contact-us-right">moyu@moyu-travel.com</span>
				</div>
				<div class="contact-us-item">
					<span class="contact-us-left">总部办公地址</span
					><span class="contact-us-right">上海市杨浦区杨树浦路658号中交滨江广场A座19楼</span>
				</div>
			</div>
		</div>
		<div v-show="path !== '/login'" class="footer">
			<div class="footer-content">
				<div @click="goKeepOnRecord" class="footer-content-left">
					{{ keepOnRecordObj.title }}
				</div>
				<div class="footer-content-right">
					<div
						@click="goKeepOnRecord"
						class="keep-on-record-icon"
						:style="{ backgroundImage: `url(${keepOnRecordObj.picPath})` }"
					></div>
					<span @click="goKeepOnRecord" class="keep-on-record-number">{{
						keepOnRecordObj.content
					}}</span>
				</div>
			</div>
		</div>
		<el-dialog
			title="品牌动态"
			:visible.sync="brandVisible"
			custom-class="dynamic-dialog brand-dialog"
			append-to-body
			width="860px"
			top="6vh"
		>
			<div class="brand-dialog-body">
				<div class="brand-photo">
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178884582198546658625.jpeg"
						alt="品牌动态"
					/>
				</div>
				<div class="brand-copy">
					<p>
						墨鱼旅行是一个有趣的社交旅行平台，专注解决“和谁去”的问题。我们的使命是为用户匹配最精准的旅行搭子，做最安全的保障机制，筛选符合不同圈层人群的专属旅行。
					</p>
					<p>
						在出行前用户可以在平台互动聊天交个朋友，也可以发起自己的搭伴行程，还可以选择和志同道合的队友组队出发。我们围绕“同频”的概念不断深耕，通过同样目的地、出发地、同年龄层、同兴趣层、同职业、同口味等多项维度精准地帮助用户匹配同频的搭子。
					</p>
					<p>
						安全方面平台不仅提供了实名认证，还有更多的爽约押金，社会身份认证、平台交易保障、平台保险保障等安全保障机制。在筛选行程上面，我们先定人群圈层再定产品，根据每个圈层人群对关注的关键的指标筛选主题行程。一次完美的旅行不仅要有创意的玩法，舒适的体验，更要有志同道合、灵魂共鸣的同行人。
					</p>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="人物动态"
			:visible.sync="personVisible"
			custom-class="dynamic-dialog person-dialog"
			append-to-body
			width="1040px"
			top="6vh"
		>
			<div class="person-dialog-body">
				<div class="person-photo">
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178884597192817047704.png"
						alt="马丽萍"
					/>
				</div>
				<div class="person-copy">
					<div class="person-name">马丽萍</div>
					<div class="person-role">墨鱼旅行创始人兼首席执行官</div>
					<div class="person-meta">
						长江商学院19MBA / EMBA / VC Start<br />
						2021年入选《胡润U30中国创业领袖》<br />
						2025年入选《胡润U40中国创业先锋》
					</div>
					<p>
						她是一位连续创业者与深度旅行探索者，个人足迹覆盖全球超过80个国家和地区。基于对“和谁去，比去哪里更重要”这一核心社会洞察，她于2018年创立墨鱼旅行，开创“社交旅行”新品类，推动平台从线上旅行社交向“线上智能匹配+线下社交体验”双轮驱动升级，致力于打造全球最大的旅行社交平台，解决现代人在数字化时代的旅行孤独感，帮助用户找到价值观契合、兴趣同频的旅伴。
					</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { articleTagList } from "@/http/api";
	import MobileHeader from "@/components/MobileHeader.vue";
	export default {
		components: {
			MobileHeader,
		},
		data() {
			return {
				isMobile: this.$isMobile,
				path: "",
				color: "#333",
				brandVisible: false,
				personVisible: false,
				navList: [
					{ id: 1, name: "首页", path: "/home" },
					{ id: 2, name: "定制游", path: "/customTour" },
					{ id: 3, name: "驴友社区", path: "/travelCommunity" },
					{ id: 4, name: "组队", path: "/goWith" },
					{ id: 5, name: "热门路线", path: "/hotRoute" },
					{ id: 6, name: "APP下载", path: "/appDownload" },
				],
				keepOnRecordObj: {
					picPath:
						"https://oss.cuttlefish.vip/file/backstageManagement/serveManage/1661233212930.png",
					url: "https://beian.miit.gov.cn/",
					title: "备案号：沪ICP备18044950号-1",
					content: "沪公网安备 31011302005786号",
				},
			};
		},
		computed: {
			showContactSection() {
				return this.path === "/home" || this.path === "/appDownload";
			},
		},
		created() {
			this.getArticleTagList();
		},
		mounted() {
			this.path = this.$route.path;
			this.logoType();
		},
		methods: {
			routerJump(path) {
				this.$router.push(path);
				this.logoType();
			},
			logoType() {
				this.color = "#333";
			},
			// 获取备案信息
			async getArticleTagList() {
				const { data: res } = await articleTagList({
					nid: "os_keep_on_record",
				});
				if (res.code === 200 && res.data.length > 0) {
					if (!res.data[0].picPath.startsWith("http")) {
						res.data[0].picPath = this.$oss + res.data[0].picPath;
					}
					this.keepOnRecordObj = {
						picPath: res.data[0].picPath,
						url: res.data[0].introduction,
						title: res.data[0].title,
						content: res.data[0].content,
					};
				}
			},
			// 打开备案网站
			goKeepOnRecord() {
				open(this.keepOnRecordObj.url);
			},
		},
		watch: {
			$route(route) {
				this.path = route.path;
				this.logoType();
			},
		},
	};
</script>

<style scope lang="scss">
	.nav {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 0 120px;
		width: 100%;
		height: 122px;
		z-index: 999;
		background-color: #fff;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
		.logo {
			cursor: pointer;
			height: 48px;
			img {
				display: block;
				height: 48px;
				width: auto;
			}
		}
		.nav-list {
			display: flex;
			margin: 0;
			padding: 0;
			height: 42px;
			li {
				display: flex;
				align-items: center;
				margin-right: 48px;
				font-size: 18px;
				font-weight: 500;
				cursor: pointer;
				&:last-child {
					margin-right: 0;
				}
				.nav-button {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 118px;
					height: 42px;
					border: 0;
					border-radius: 23px;
					color: #fff;
					background: linear-gradient(
						139deg,
						#35a4ff 0%,
						#57cdff 55%,
						#5ad0fe 100%
					);
				}
			}
		}
	}
	.contact-us {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 0;
		padding: 48px 24px 24px;
		text-align: center;
		.dynamic-actions {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			margin-bottom: 56px;
			.dynamic-btn {
				min-width: 240px;
				height: 64px;
				padding: 0 52px;
				border: 1px solid transparent;
				border-radius: 32px;
				font-size: 20px;
				font-weight: 600;
				font-family: PingFangSC-Medium, PingFang SC;
				letter-spacing: 2px;
				cursor: pointer;
				outline: none;
				transition: transform 0.25s ease, box-shadow 0.25s ease,
					background 0.25s ease, color 0.25s ease;
				& + .dynamic-btn {
					margin-left: 32px;
				}
				&.brand {
					color: #fff;
					background: linear-gradient(
						139deg,
						#35a4ff 0%,
						#57cdff 55%,
						#5ad0fe 100%
					);
					box-shadow: 0 8px 20px rgba(38, 161, 255, 0.28);
					&:hover {
						transform: translateY(-3px) scale(1.04);
						box-shadow: 0 14px 28px rgba(38, 161, 255, 0.42);
					}
				}
				&.person {
					color: #e86a2b;
					background: #fff7f1;
					border-color: #f3c4a8;
					box-shadow: 0 8px 18px rgba(232, 106, 43, 0.12);
					&:hover {
						color: #fff;
						background: linear-gradient(139deg, #ff8a4c 0%, #e86a2b 100%);
						transform: translateY(-3px) scale(1.04);
						box-shadow: 0 14px 28px rgba(232, 106, 43, 0.32);
					}
				}
			}
		}
		.contact-us-title {
			margin-bottom: 58px;
			font-size: 28px;
			font-weight: 800;
			color: #333;
		}
		.contact-us-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;
		}
		.contact-us-item {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 40px;
			&:last-child {
				margin-bottom: 0;
			}
			.contact-us-left {
				flex-shrink: 0;
				margin-right: 42px;
				font-size: 20px;
				font-weight: 400;
				font-family: PingFangSC-Regular, PingFang SC;
				color: #999999;
				white-space: nowrap;
			}
			.contact-us-right {
				font-size: 20px;
				font-family: PingFang-SC-Heavy, PingFang-SC;
				font-weight: 600;
				color: #333333;
				text-align: center;
				word-break: break-word;
			}
		}
	}
	@media screen and (max-width: 768px) {
		.contact-us {
			padding: 40px 16px 32px;
		}
	}
	.footer {
		overflow: hidden;
		height: 188px;
		background: #063b63;
		.footer-content {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 133px;
			font-size: 14px;
			color: #fff;
			font-family: PingFangSC-Regular, PingFang SC;
			.footer-content-left {
				cursor: pointer;
			}
			.footer-content-right {
				display: flex;
				align-items: center;
				margin-left: 63px;

				.keep-on-record-icon {
					margin-right: 8px;
					width: 20px;
					height: 20px;
					background-size: 100% 100%;
					cursor: pointer;
				}
				.keep-on-record-number {
					cursor: pointer;
				}
			}
		}
	}
	.dynamic-dialog {
		border-radius: 20px;
		overflow: hidden;
		.el-dialog__header {
			padding: 22px 28px 6px;
		}
		.el-dialog__title {
			font-size: 22px;
			font-weight: 800;
			color: #333;
		}
		.el-dialog__body {
			padding: 8px 28px 28px;
		}
		.el-dialog__headerbtn .el-dialog__close {
			font-size: 20px;
			color: #999;
		}
	}
	.el-dialog__wrapper .dynamic-dialog {
		animation: dynamic-scale-in 0.35s cubic-bezier(0.16, 1, 0.3, 1);
	}
	@keyframes dynamic-scale-in {
		0% {
			transform: scale(0.86);
			opacity: 0;
		}
		100% {
			transform: scale(1);
			opacity: 1;
		}
	}
	.brand-dialog-body {
		.brand-photo {
			overflow: hidden;
			border-radius: 14px;
			img {
				display: block;
				width: 100%;
			}
		}
		.brand-copy {
			margin-top: 22px;
			p {
				margin: 0 0 14px;
				font-size: 15px;
				line-height: 1.9;
				color: #555;
				text-align: justify;
				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
	.person-dialog {
		.el-dialog__body {
			padding: 0 0 0;
		}
	}
	.person-dialog-body {
		display: flex;
		align-items: stretch;
		min-height: 560px;
		background: #fff;
		.person-photo {
			flex: 0 0 400px;
			overflow: hidden;
			background: linear-gradient(180deg, #fff8f0 0%, #f8d7b8 100%);
			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center 12%;
			}
		}
		.person-copy {
			display: flex;
			flex: 1;
			flex-direction: column;
			justify-content: center;
			padding: 48px 48px 48px 40px;
			text-align: left;
			.person-name {
				font-size: 28px;
				font-weight: 800;
				color: #222;
				letter-spacing: 1px;
			}
			.person-role {
				margin: 10px 0 18px;
				font-size: 16px;
				font-weight: 600;
				color: #e86a2b;
			}
			.person-meta {
				margin-bottom: 22px;
				padding: 14px 16px;
				border-left: 3px solid #e86a2b;
				background: #fff7f1;
				font-size: 13px;
				line-height: 1.8;
				color: #8a5a3a;
			}
			p {
				margin: 0;
				font-size: 15px;
				line-height: 1.9;
				color: #555;
			}
		}
	}
	@media screen and (max-width: 768px) {
		.dynamic-dialog {
			width: 92% !important;
			margin-bottom: 24px;
		}
		.dynamic-actions .dynamic-btn + .dynamic-btn {
			margin-left: 12px;
		}
		.person-dialog-body {
			flex-direction: column;
			min-height: 0;
			.person-photo {
				flex: none;
				width: 100%;
				height: 320px;
			}
			.person-copy {
				padding: 24px 20px 28px;
			}
		}
	}
</style>